export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Arrow-Both-Gray-52eaadfbd7f34b52bb2ac26d28d33a89.svg";